module.exports = __webpack_public_path__ + "img/pin-icon-active.3538b564.svg";